import Image from "next/image";
import Link from "next/link";

interface Coin {
  image_uri: string;
  name: string;
  symbol: string;
  description: string;
  market_cap: number;
  market_cap_usd: string;
  bonding_curve_completion: number | undefined;
  token_address: string | undefined;
  creator: string;
  createdAt: string;
  category: string;
}

const formatMarketCap = (value: number) => {
  if (value >= 1000000000) {
    // Billions
    return `${(value / 1000000000).toFixed(1)}B`;
  } else if (value >= 1000000) {
    // Millions
    return `${(value / 1000000).toFixed(1)}M`;
  } else if (value >= 1000) {
    // Thousands
    return `${(value / 1000).toFixed(1)}K`;
  } else {
    return value.toFixed(1);
  }
};

export default function CoinCard({ coin }: { coin: Coin }) {
  return (
    <Link
      href={`/token/${coin.token_address}`}
      className="bg-gradient-to-b from-[#0F0E16] to-[#14121A] border-2 border-[#1B1923] backdrop-blur-lg rounded-2xl p-6 flex flex-col hover:scale-[102%] hover:from-orange-500/5 hover:border-orange-500/5 transition-all duration-300"
    >
      <div className="flex items-start justify-between mb-2">
        <div className="flex flex-col md:h-auto  items-start gap-5">
          <Image
            src={coin.image_uri || "/placeholder.svg"}
            alt={coin.name}
            width={100}
            height={100}
            className="rounded-full overflow-hidden object-cover aspect-square"
          />
          <div className="">
            <h3 className="text-neutral-400 md:text-xl text-sm font-bold">
              {coin.name} <span className="text-white">{coin.symbol}</span>
            </h3>
            <p className="text-gray-400 md:text-sm text-xs mt-1 max-w-3xl">
              {coin.description}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-auto pt-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-white font-bold">
            ${formatMarketCap(Number(coin.market_cap_usd))}
          </span>
          <span className="text-gray-400 text-sm">Bonding Curve</span>
        </div>
        <div className="w-full bg-[#24222B] rounded-full h-2 overflow-hidden">
          <div
            className="bg-blue-500 h-full rounded-full"
            style={{ width: `${coin.bonding_curve_completion}%` }}
          />
        </div>
      </div>
    </Link>
  );
}
